import React from 'react';
import Header from '../../common/header/header';
import Footer from '../../common/footer/footer';
import LegalDocumentBody from '../../common/legalDocumentBody/legalDocumentBody';
import offerFile from '../../../files/Договор оферты.pdf';
import { offerDocumentText } from '../../../data/legal/offerText';
import classes from '../../common/legalPage/legalPage.module.css';

const OfferPage = () => {
  return (
    <div className={classes.page}>
      <Header />
      <main className={classes.main}>
        <section className={classes.card}>
          <h1 className={classes.title}>Публичная оферта</h1>
          <p className={classes.subtitle}>
            Договор оферты на оказание услуг Салона мужской эстетики «Л.Е.В.»
          </p>

          <div className={classes.meta}>
            <div>Исполнитель: ИП Лила Екатерина Сергеевна</div>
            <div>ИНН: 650803245599</div>
            <div>ОГРНИП: 325774600156114</div>
            <div>Адрес: 119002, г. Москва, Смоленский бульвар, 22/14</div>
            <div>E-mail: salon.l.e.v@yandex.ru</div>
            <div>Телефон: +7 915 189 7033</div>
          </div>

          <a
            href={offerFile}
            download="Договор оферты.pdf"
            className={classes.download}
          >
            Скачать полный текст оферты (PDF)
          </a>

          <LegalDocumentBody text={offerDocumentText} />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default OfferPage;
